import React from 'react'
import { Link } from 'react-router-dom'
import PageHeader from '../components/PageHeader'
import Reveal from '../components/Reveal'
import Icon from '../components/Icons'
import { CallToAction } from './Home'

const topics = [
  { title: 'Choosing the right technology partner for your organisation', tag: 'ICT strategy' },
  { title: 'What to prepare before procuring an ICT solution', tag: 'Procurement' },
  { title: 'Building practical digital systems for property operations', tag: 'Systems' },
]

const Blog = () => (
  <main>
    <PageHeader
      index="04"
      label="Insights"
      lines={[
        'Notes from',
        <>
          our <span className="accent-italic">practice</span>
        </>,
      ]}
      description="Practical writing on ICT delivery, procurement, and digital products in Kenya."
      crumb="Insights"
    />

    <section className="section">
      <div className="container">
        <Reveal className="border-y border-ink-950/10 py-10 md:grid md:grid-cols-[10rem_1fr] md:gap-12">
          <div className="flex items-baseline gap-4">
            <span className="index-num">01</span>
            <span className="label">Featured article</span>
          </div>
          <article className="mt-8 md:mt-0">
            <span className="label text-accent-500">ICT strategy · 4 min read</span>
            <h2 className="display-2 mt-6 max-w-3xl">Choose a technology partner for the whole journey, not one task.</h2>
            <div className="mt-8 max-w-2xl space-y-5 text-lg leading-relaxed text-ink-500">
              <p>
                A useful technology project begins with the operating problem, not the product list. Before comparing solutions, define what needs to improve: speed, visibility, security, service, or the ability to scale.
              </p>
              <p>
                The strongest delivery partners can connect that problem to the full solution — advisory, software, infrastructure, procurement, deployment, and support. This reduces hand-offs, makes accountability clear, and helps the finished system fit the people who will use it every day.
              </p>
              <p>
                At Aldaron Limited, we start with the context and build from there: a scope that is practical, costed, and ready for direct procurement or competitive tender.
              </p>
            </div>
            <Link to="/contact" className="btn btn-outline mt-10">
              Start the conversation
              <Icon name="arrow" className="h-4 w-4" />
            </Link>
          </article>
        </Reveal>

        <div className="mt-16">
          <p className="label mb-2">Coming up</p>
          {topics.map((topic, i) => (
            <Reveal key={topic.title} delay={i * 60}>
              <article className="grid items-baseline gap-x-10 gap-y-3 border-t border-ink-950/10 py-9 last:border-b md:grid-cols-[4rem_1fr_10rem]">
                <span className="index-num">{String(i + 1).padStart(2, '0')}</span>
                <h3 className="display-3 max-w-2xl text-ink-950/75">{topic.title}</h3>
                <div className="flex items-baseline gap-4 md:justify-end">
                  <span className="label">{topic.tag}</span>
                </div>
              </article>
            </Reveal>
          ))}
        </div>

        <Reveal delay={120} className="mt-14">
          <Link to="/contact" className="btn btn-outline">
            Ask us about a topic
            <Icon name="arrow" className="h-4 w-4" />
          </Link>
        </Reveal>
      </div>
    </section>

    <CallToAction />
  </main>
)

export default Blog
